<script setup lang="ts">
import { ProductsList } from "~/models/Content/ContentProducts"

const props = defineProps({
  product: {
    type: Object as PropType<ProductsList>,
    required: true,
  },
  released: {
    type: Boolean,
    default: true,
  },
})

const router = useRouter()

const { catalogueFilteredByEAN } = useEcommerceCatalogue()

const productImage = computed(() => {
  return catalogueFilteredByEAN(
    props.product.variants.find(v => v.ean)?.ean,
  )?.images[0]
})
</script>

<template>
  <div
    class="flex flex-col rounded-2xl bg-platform-white font-national2 drop-shadow-xl lg:gap-14 lg:flex-row"
  >
    <img
      v-if="productImage"
      :src="productImage.url"
      class="h-[281px] w-full cursor-pointer rounded-bl-none rounded-tl-2xl rounded-tr-2xl object-contain p-4 md:h-auto lg:w-[320px] lg:rounded-bl-2xl lg:rounded-tl-2xl lg:rounded-tr-none"
      :class="`bg-${product.theme}-lightest`"
      :alt="
        productImage.altText ||
        `Produktillustrasjon for ${product.productTitle} `
      "
      @click="
        product.hasAtLeastOneReleasedProduct &&
          router.push(`/produkter/${product.urlFormatProductTitle}`)
      "
    />
    <div
      v-else
      class="h-[281px] w-full cursor-pointer rounded-bl-none rounded-tl-2xl rounded-tr-2xl p-4 md:h-[320px] lg:w-[320px] lg:min-w-[320px] lg:rounded-bl-2xl lg:rounded-tl-2xl lg:rounded-tr-none"
      :class="`bg-${product.theme}-lightest`"
    ></div>
    <div
      class="flex flex-col w-full px-6 py-7 lg:py-10 lg:pl-0 lg:pr-24"
    >
      <h4
        class="font-national2compressed text-[32px] font-extrabold uppercase leading-10 text-[--theme-dark] md:text-5xl"
      >
        Kunne
        <span v-html="product.productTitleHtml" />
        {{ !product.productTitleHtml ? product.productTitle : null }}
      </h4>
      <p
        v-if="
          product.groupSalesPitch &&
          product.groupSalesPitch.length > 2
        "
        class="pr-10 mt-2 mb-5 text-lg lg:mb-10 lg:mt-4 md:text-xl"
        v-html="product.groupSalesPitch"
      />
      <UProductActions :product="product" />
    </div>
  </div>
</template>

<style scoped lang="postcss"></style>
